import React from 'react'
import Team from './Team';
import { useNavigate } from 'react-router-dom';

const Home = () => {
    const navigate = useNavigate();
  return (
    <div>
            <div id="header-carousel" className="carousel slide carousel-fade" data-bs-ride="carousel">
      <div className="carousel-inner">
        <div className="carousel-item active">
          <img className="w-100" src="assets/img/carousel-1.jpg" alt="Image" />
          <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
            <div className="p-3" style={{maxWidth: 900}}>
              <h5 className="text-white text-uppercase mb-3 animated slideInDown">Experience</h5>
              <h1 className="display-1 text-white mb-md-4 animated zoomIn">Best Courses within the Shortterm</h1>
              <a href="" className="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft" onClick={(e)=>{e.preventDefault();navigate('/contact')}} >Contact Us</a>
              <a href="" className="btn btn-outline-light py-md-3 px-md-5 animated slideInRight" onClick={(e)=>{e.preventDefault();navigate('/about')}} >About Us</a>
            </div>
          </div>
        </div>
        <div className="carousel-item">
          <img className="w-100" src="assets/img/carousel-2.jpg" alt="Image" />
          <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
            <div className="p-3" style={{maxWidth: 900}}>
              <h5 className="text-white text-uppercase mb-3 animated slideInDown">Creative &amp; Innovative</h5>
              <h1 className="display-1 text-white mb-md-4 animated zoomIn">Creative &amp; Innovative Digital Trainer</h1>
              <a href="" className="btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft">Contact Us</a>
              <a href="" className="btn btn-outline-light py-md-3 px-md-5 animated slideInRight">About Us</a>
            </div>
          </div>
        </div>
      </div>
      <button className="carousel-control-prev" type="button" data-bs-target="#header-carousel" data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="true" />
        <span className="visually-hidden">Previous</span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target="#header-carousel" data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="true" />
        <span className="visually-hidden">Next</span>
      </button>
    </div>

    </div>
  )
}

export default Home